/*
 * Stilnovo editorial motion controller (phase 2).
 *
 * One controller for the optional hero motion layer. It never adds autoplay
 * attributes to the markup: playback is only started from script after the
 * motion preference and viewport are known, and any load/play failure hides
 * the layer so the static editorial photo underneath stays visible.
 *
 * Idempotent: a layer is initialised once and re-initialised safely when the
 * theme editor reloads its section.
 */
(function () {
  'use strict';

  var ROOT = '[data-stilnovo-motion]';
  var READY = 'motionReady';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var canAutoplayOnViewport = window.matchMedia('(min-width: 750px)');

  function attr(root, name, fallback) {
    var value = root.getAttribute(name);
    return value === null || value === '' ? fallback : value;
  }

  function init(root) {
    if (!root || root.dataset[READY] === 'true') {
      return;
    }

    var video = root.querySelector('video');
    var toggle = root.querySelector('[data-stilnovo-motion-toggle]');
    if (!video || !toggle) {
      return;
    }

    root.dataset[READY] = 'true';

    var label = toggle.querySelector('[data-stilnovo-motion-toggle-label]');
    var pauseLabel = attr(root, 'data-pause-label', 'Pause');
    var playLabel = attr(root, 'data-play-label', 'Play');
    var pauseAria = attr(root, 'data-control-pause', pauseLabel);
    var playAria = attr(root, 'data-control-play', playLabel);
    var deferredSource = video.getAttribute('data-src');
    var settled = false;

    function reflect(playing) {
      root.setAttribute('data-motion-state', playing ? 'playing' : 'paused');
      if (label) {
        label.textContent = playing ? pauseLabel : playLabel;
      }
      toggle.setAttribute('aria-label', playing ? pauseAria : playAria);
      toggle.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }

    function fail() {
      if (settled) {
        return;
      }
      settled = true;
      root.setAttribute('data-motion-state', 'failed');
      video.setAttribute('hidden', 'hidden');
      toggle.setAttribute('hidden', 'hidden');
    }

    function start() {
      if (deferredSource && !video.getAttribute('src')) {
        video.setAttribute('src', deferredSource);
      }

      var attempt = video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(function () {
          if (!settled) {
            settled = true;
            reflect(true);
          }
        }).catch(function () {
          if (!settled) {
            reflect(false);
          }
        });
      }
    }

    function stop() {
      video.pause();
      reflect(false);
    }

    video.addEventListener('error', fail);
    video.addEventListener('playing', function () {
      settled = true;
      reflect(true);
    });
    video.addEventListener('pause', function () {
      if (root.getAttribute('data-motion-state') !== 'failed') {
        reflect(false);
      }
    });

    toggle.addEventListener('click', function () {
      if (video.paused) {
        start();
      } else {
        stop();
      }
    });

    toggle.removeAttribute('hidden');
    reflect(false);

    // Reduced motion: stay on the still photo until the visitor asks for motion.
    if (reducedMotion.matches) {
      toggle.setAttribute('aria-label', playAria);
      return;
    }

    // Small screens keep the poster; the control stays available for opt-in.
    if (!canAutoplayOnViewport.matches) {
      return;
    }

    start();
  }

  function initAll(scope) {
    var layers = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < layers.length; i++) {
      init(layers[i]);
    }
  }

  function stopAll(scope) {
    var layers = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < layers.length; i++) {
      var video = layers[i].querySelector('video');
      if (video) {
        video.pause();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    stopAll(event.target);
  });
})();

/* Keep collection browsing limited to products available to order. */
(function () {
  'use strict';
  var stockKey = 'filter.v.availability';
  function collectionUrl(value) {
    var url;
    try { url = new URL(value, window.location.href); } catch (error) { return null; }
    return url.origin === window.location.origin && /\/collections\/[^/]+\/?$/.test(url.pathname) ? url : null;
  }
  function setInStock(url, resetPage) {
    var values = url.searchParams.getAll(stockKey);
    if (values.length === 1 && values[0] === '1') return false;
    url.searchParams.set(stockKey, '1');
    if (resetPage) url.searchParams.delete('page');
    return true;
  }
  function normalizeCurrentCollection() {
    var url = collectionUrl(window.location.href);
    if (url && setInStock(url, true)) {
      window.location.replace(url.href);
      return true;
    }
    return false;
  }
  if (normalizeCurrentCollection()) return;
  function normalizeLink(anchor) {
    var url = collectionUrl(anchor.getAttribute('href'));
    if (url && setInStock(url, true)) anchor.setAttribute('href', url.href);
  }
  function normalizeFacets() {
    document.querySelectorAll('main form').forEach(function (form) {
      if (!/^Facet/.test(form.id) && !form.querySelector('[name^="filter."], [name="sort_by"]')) return;
      var hidden = form.querySelector('input[type="hidden"][name="' + stockKey + '"]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = stockKey;
        form.appendChild(hidden);
      }
      hidden.value = '1';
      form.querySelectorAll('input[type="checkbox"][name="' + stockKey + '"]').forEach(function (input) {
        input.disabled = true;
        input.checked = input.value === '1';
        if (input.value === '0') {
          var row = input.closest('li') || input.closest('label');
          if (row) row.hidden = true;
        }
      });
    });
  }
  function refresh() {
    document.querySelectorAll('a[href]').forEach(normalizeLink);
    if (collectionUrl(window.location.href)) normalizeFacets();
  }
  function initialize() {
    refresh();
    document.addEventListener('click', function (event) {
      var anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (anchor) normalizeLink(anchor);
    }, true);
    if (!collectionUrl(window.location.href)) return;
    var main = document.querySelector('main');
    if (main) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        queueMicrotask(function () { queued = false; refresh(); });
      }).observe(main, { childList: true, subtree: true });
    }
    document.addEventListener('input', normalizeFacets, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.addEventListener('pageshow', function () {
    if (!normalizeCurrentCollection()) refresh();
  });
})();
